import React, { ReactNode } from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { LoadingSpinner } from '../../../components/atoms/LoadingSpinner';
import { StatusInfo, StatusInfoModifier } from './partials/StatusInfo';
import { Content } from './partials/Content';
import { Message } from './partials/Message';

type StatusInfoLoading = {
  message?: ReactNode;
  modifier?: Modifier<StatusInfoModifier>;
  dataFormStatus?: 'sending' | 'forwarding';
};

export function StatusInfoLoading({ message, modifier, dataFormStatus }: StatusInfoLoading) {
  return (
    <StatusInfo modifier={modifier} dataFormStatus={dataFormStatus}>
      <Content>
        <span className="status-info__loading">
          <LoadingSpinner />
        </span>
        <Message>{message}</Message>
      </Content>
    </StatusInfo>
  );
}
